import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";

// Enum options extracted from Ruby MacroKeyword.macro_types
export const macroTypeOptions = [
  { value: "events", label: "Events" },
  { value: "index", label: "Index" },
  { value: "commodities", label: "Commodities" },
  { value: "currency", label: "Currency" },
  { value: "rate", label: "Rate" },
  { value: "continent", label: "Continent" },
  { value: "city", label: "City" },
  { value: "country", label: "Country" },
  { value: "press", label: "Press" },
  { value: "central_bank", label: "Central Bank" },
  { value: "governmental", label: "Governmental" },
  { value: "country_group", label: "Country Group" },
  { value: "person", label: "Person" },
  { value: "organization", label: "Organization" },
  { value: "public_entity", label: "Public Entity" },
  { value: "corporation", label: "Corporation" },
  { value: "financial_product", label: "Financial Product" },
];

export const filterMacroKeywordSchema = z.object({
  id_contains: z.string().nullable().optional(),
  time_serie_id_contains: z.string().nullable().optional(),
  name_contains: z.string().nullable().optional(),
  macro_type_contains: z.string().nullable().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  updated_at_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterMacroKeywordSchema = z.infer<typeof filterMacroKeywordSchema>;

export const fields: Field[] = [
  {
    name: "id_contains",
    label: "ID",
    type: "input",
    input_type: "text",
  },
  {
    name: "time_serie_id_contains",
    label: "Time Series ID",
    type: "input",
    input_type: "text",
  },
  {
    name: "name_contains",
    label: "Name",
    type: "input",
  },
  {
    name: "macro_type_contains",
    label: "Macro Type",
    type: "select",
    useTranslation: false,
    options: macroTypeOptions,
  },
  {
    name: "created_at_from",
    label: "Created From",
    type: "date",
  },
  {
    name: "created_at_to",
    label: "Created To",
    type: "date",
  },
  {
    name: "updated_at_from",
    label: "Updated From",
    type: "date",
  },
  {
    name: "updated_at_to",
    label: "Updated To",
    type: "date",
  },
];

export const client = "ia-quantilia";

export function FilterMacroKeyword() {
  return (
    <FilterTable
      client={client}
      schema={filterMacroKeywordSchema}
      tableName="macro_keywords"
      customBuildPath={() => `${client}/macro_keywords`}
      fields={fields}
    />
  );
}
